export { default } from './ObservationNotes.component';
